import { apiEmployeeFacility } from './apiEmployeeFacility'
import { apiEmployeeLocation } from './apiEmployeeLocation'
import { apiProductionCorrections } from './apiProductionCorrections'
import { apiProductionEmployees } from './apiProductionEmployees'
import { apiDeliveryUnits } from './apiDeliveryUnits'

const apiEmployees = {
	...apiEmployeeLocation,
	...apiEmployeeFacility,
	...apiProductionCorrections,
	...apiProductionEmployees,
	...apiDeliveryUnits,
}

export { apiEmployees }
